import { z } from 'zod';
import { FlowBlockUnionSchema } from '../flowDefinition/blocks/union.js';
import { FlowApiPageLimitSchema, FlowApiPageOffsetSchema } from '../pagination/pageLimit.js';
/**
 * A block template is a saved block that can be cloned onto any flow. flow-api serves these at
 * `/flow-block-templates` and, for now, at the legacy `/flow-templates`, which never carried flow
 * definition templates despite the name.
 *
 * The staff block picker calls them favourites when it filters to the caller's own and renders them
 * with a star, so starring a block creates one of these and unstarring deletes it. There is no
 * favourite flag: the record is the star.
 */
/** Query parameters `GET /flow-block-templates/blocks` accepts. */
export const FlowBlockTemplateListQuerySchema = z.object({
    q: z
        .string()
        .describe('Return only templates whose name contains this. Ignored when name is given.')
        .optional(),
    organizationId: z.string().describe('Return only templates of this organization.').optional(),
    name: z.string().describe('Return only templates with exactly this name.').optional(),
    createdById: z
        .string()
        .describe("Return only templates saved by this user. The block picker's stars are this filter.")
        .optional(),
    createdByEmail: z.string().describe('Return only templates saved by this user.').optional(),
    limit: FlowApiPageLimitSchema.describe('How many templates to return.').optional(),
    offset: FlowApiPageOffsetSchema.describe('How many matches to skip, for paging.').optional(),
    orderBy: z.string().describe('Column to order by, such as name.').optional(),
    orderDirection: z.enum(['asc', 'desc']).describe('Direction to order by.').optional(),
});
/** Path parameters the endpoints addressing one block template accept. */
export const FlowBlockTemplateIdParamsSchema = z.object({
    id: z.uuid().describe('The block template.'),
});
/**
 * Body `POST /flow-block-templates/blocks` accepts. Structural validation only: flow-api additionally
 * checks that the name is free and that the block's database references resolve.
 *
 * A null organization saves the template for everyone; the name and description are the template's
 * own, which is why the block carries its own pair and they are not read from it.
 */
export const FlowBlockTemplateCreateBodySchema = z.object({
    name: z.string(),
    description: z.string(),
    organizationId: z
        .string()
        .describe('Organization the template belongs to, or null to save it for everyone.')
        .nullish(),
    blockTemplate: FlowBlockUnionSchema.describe('The block to save, with its configuration.'),
});
//# sourceMappingURL=flowBlockTemplate.js.map